import React from 'react';

import { BIO_STATES, BIO_NAMES } from '@/components/onboarding/Shared';
import { type bioPageProps } from '@/types/globals';

import PreferencePage from './PreferencePage';

const placeholder = `In your own words, tell us about your meeting preferences. Here’s an example from Mat, our founder:

    •   Any meeting outside of 10am-4pm is ‘out of policy’. I try to keep 12pm-1pm for lunch.
    •   I won’t meet before 10am on a Saturday or public holiday, or before 12pm on a Sunday, unless it’s an emergency.
    •   I reserve Mondays and Fridays for getting work done.
    •   I’ll waive my rules if you are more than 3 time zones away from me.
    •   I strongly prefer face-to-face meetings to phone calls, and phone calls to video meetings.
    •   I strongly prefer short meetings (less than 30 mins) to longer ones.
    •   If you’re asking for a meeting and we’ve never met before, I’ll do a 25 minute meeting on Tuesday or Thursday afternoons.`;

function MeetingPreferencesPanel({
    isModal = false,
    extendContinue = null,
    overrideBack = null,
    isEdit,
    openBrief,
}: bioPageProps) {
    return (
        <PreferencePage
            fieldName="meetingPreferences"
            header="Tell us about your meeting preferences?"
            subHeader="In your own words, tell us more about how you prefer to handle meetings. Are there certain days or times that work best? Do you prefer in-person or virtual? Share anything that might help guide your future contacts."
            subHeaderWidth="max-w-[655px]"
            inputLabelText="What are your meeting preferences?"
            inputPlaceholder={placeholder}
            bioStep={3}
            stepNames={BIO_NAMES}
            totalSteps={5}
            bioState={BIO_STATES.meetingPreferences}
            isModal={isModal}
            isEdit={isEdit}
            extendContinue={extendContinue}
            overrideBack={overrideBack}
            openBrief={openBrief}
        />
    );
}

export default MeetingPreferencesPanel;
